import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";
const FAQKundenserviceSection = () => <FAQSectionI18n translationPrefix="kundenserviceSolution" />;
export default FAQKundenserviceSection;
